import api from './api';
import { 
  Cliente, 
  Venta, 
  VentaFormData, 
  DetalleVenta, 
  ReporteVenta, 
  ApiResponse 
} from '../types';

// Servicios para Clientes
export const clienteService = {
  getAll: (params?: {
    activo?: boolean;
    search?: string;
  }) => 
    api.get<ApiResponse<Cliente>>('/ventas/clientes/', { params }),
  
  getById: (id: number) => 
    api.get<Cliente>(`/ventas/clientes/${id}/`),
  
  create: (data: Omit<Cliente, 'id' | 'fecha_registro' | 'ventas_count' | 'total_compras'>) => 
    api.post<Cliente>('/ventas/clientes/', data),
  
  update: (id: number, data: Partial<Cliente>) => 
    api.put<Cliente>(`/ventas/clientes/${id}/`, data),
  
  delete: (id: number) => 
    api.delete(`/ventas/clientes/${id}/`),
  
  toggleStatus: (id: number) => 
    api.post(`/ventas/clientes/${id}/toggle_status/`),
};

// Servicios para Ventas
export const ventaService = {
  getAll: (params?: {
    estado?: string;
    fecha_desde?: string;
    fecha_hasta?: string;
    cliente?: number;
  }) => 
    api.get<ApiResponse<Venta>>('/ventas/ventas/', { params }),
  
  getById: (id: number) => 
    api.get<Venta>(`/ventas/ventas/${id}/`),
  
  create: (data: VentaFormData) => 
    api.post<Venta>('/ventas/ventas/', data),
  
  update: (id: number, data: Partial<VentaFormData>) => 
    api.put<Venta>(`/ventas/ventas/${id}/`, data),
  
  delete: (id: number) => 
    api.delete(`/ventas/ventas/${id}/`),
  
  getReporteDiario: (fecha?: string) => 
    api.get<ReporteVenta>('/ventas/ventas/reporte_diario/', { 
      params: { fecha } 
    }),
  
  getReporteSemanal: () => 
    api.get('/ventas/ventas/reporte_semanal/'),
};

// Servicios para Detalles de Venta
export const detalleVentaService = {
  getAll: () => 
    api.get<ApiResponse<DetalleVenta>>('/ventas/detalles/'),
  
  getById: (id: number) => 
    api.get<DetalleVenta>(`/ventas/detalles/${id}/`),
};